<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('allAboutMyDay.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('allAboutMyDay.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-space-x-2">
            <ts-button
              color="info"
              outline
              @click="addNew"
              v-if="!isStudent && !isParent"
              >{{ $t('add_new') }}</ts-button
            >
            <!-- <ts-button
              @click="onManualRelease"
              :waiting="waiting"
              color="info"
              :disabled="setting.is_all_about_my_day_auto"
              v-if="!isStudent && !isParent"
              >{{ $t('release') }}</ts-button
            > -->
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'activity_date'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{
                record.students
                  ? record.students.branch
                    ? record.students.branch.branch_name_en
                    : ''
                  : ' '
              }}
            </td>
            <td class="with-img">
              <img
                class="height-30 ts-rounded"
                :class="{ 'external-student': record.is_external }"
                v-lazy="{
                  src: photoStudent(record),
                  error: onError(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.students ? record.students.card_number : '' }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.students ? record.students.full_name_en : '' }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.students ? record.students.full_name_kh : '' }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.students ? record.students.gender : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              <table class="table-status">
                <tr
                  v-for="(item, index) in record.students.classes"
                  :key="index"
                >
                  <td>{{ item.class_name }}</td>
                </tr>
              </table>
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.activity_date }}
            </td>
            <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
              <a
                href="#"
                v-tooltip="$t('show')"
                class="text-primary mr-2"
                @click.prevent="show(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
                v-if="!isStudent && !isParent"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
                v-if="!isStudent && !isParent"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('allAboutMyDay.pageTitle')"
      centered
      style="font-weight: 600"
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="1000px"
    >
      <from-action @cancel="clearEdit" :showOnlyData="showOnly" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form.vue'
export default {
  name: 'allAboutMyDayIndex',
  components: {
    FromAction
  },
  data () {
    return {
      waiting: false,
      loading: false,
      showForm: false,
      showOnly: false,
      boyPhoto: require('../../assets/student-default-boy.png'),
      girlPhoto: require('../../assets/student-default-girl.png'),
      setting: {}
    }
  },
  computed: {
    ...mapState('allAboutMyDay', ['resources', 'pagination']),
    isStudent () {
      return this.$store.getters.isStudentLogin
    },
    isParent () {
      return this.$store.getters.isParentLogin
    },
    search: {
      get () {
        return this.$store.state.allAboutMyDay.search
      },
      set (newValue) {
        this.$store.commit('allAboutMyDay/SET_SEARCH', newValue)
        this.$store.commit('allAboutMyDay/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t('allAboutMyDay.branch'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.photo'),
          style: 'white-space: nowrap;width: 150px;'
        },
        {
          name: this.$t('allAboutMyDay.cardNumber'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.nameEn'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.nameKh'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.gender'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.class'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('allAboutMyDay.date'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  methods: {
    photoStudent (record) {
      if (record.students.photo) {
        return record.students.photo
      }

      return record.students.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onError (record) {
      event
        ? (event.target.src =
            record.students.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    setselectedStudent () {
      this.$store.commit(
        'allAboutMyDay/SET_STUDENT_ID',
        this.$store.state.selectedStudent.student_id
      )
    },
    fetchData (attributes) {
      this.setselectedStudent()
      this.loading = true
      this.$store
        .dispatch('allAboutMyDay/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('allAboutMyDay/SET_EDIT_DATA', record)
      this.showForm = true
    },
    show (record) {
      this.$store.commit('allAboutMyDay/SET_EDIT_DATA', record)
      this.showForm = true
      this.showOnly = true
    },
    clearEdit () {
      this.$store.commit('allAboutMyDay/SET_EDIT_DATA', {})
      this.showOnly = false
      this.showForm = false
      this.fetchData()
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('allAboutMyDay/destroy', record.id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    getSetting(){
      this.$store
        .dispatch('allAboutMyDay/getSetting')
        .then((response) => {
          this.setting = response.setting
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onManualRelease () {
      this.waiting = true
      this.$store
        .dispatch('allAboutMyDay/manualRelease', Object.assign({}, this.model))
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('allAboutMyDay/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getSetting()
      vm.fetchData()
    })
  }
}
</script>
<style>
.table-status {
  display: table;
  border-collapse: collapse;
  border: none;
}
.table-status td {
  padding: 2px 4px;
  border-top: none !important;
  font-size: 10px;
}
table.table-status .icon {
  visibility: hidden;
}
table.table-status tr:hover .icon {
  visibility: visible;
}
</style>
